import {
  ONBOARDING_TYPE_CSAS,
  ONBOARDING_TYPE_FREE_TRIAL,
  ONBOARDING_TYPE_PURCHASE_FULL,
  ONBOARDING_TYPE_PURCHASE_SHORT,
  ONBOARDING_TYPE_SLSP,
  SIGNUP_ROUTE
} from '../services/router-link-creator.service';

// TODO: Terrible code, needs refactoring

export const isLinkFromOnboarding = (url: string): boolean =>
  // onboarding redirects to signup, therefore only signup URLs listed below
  url.indexOf(`/${SIGNUP_ROUTE}/${ONBOARDING_TYPE_FREE_TRIAL}`) > -1 ||
  url.indexOf(`/${SIGNUP_ROUTE}/${ONBOARDING_TYPE_SLSP}`) > -1 ||
  url.indexOf(`/${SIGNUP_ROUTE}/${ONBOARDING_TYPE_CSAS}`) > -1 ||
  url.indexOf(`/${SIGNUP_ROUTE}/${ONBOARDING_TYPE_PURCHASE_SHORT.replace('-', '/')}`) > -1 ||
  url.indexOf(`/${SIGNUP_ROUTE}/${ONBOARDING_TYPE_PURCHASE_FULL.replace('-', '/')}`) > -1;

export const isLinkFromOnboradingNewDesign = (url: string): boolean =>
  // onboarding redirects to signup, therefore only onboarding URLs listed below
  url.indexOf(`/${SIGNUP_ROUTE}/${ONBOARDING_TYPE_FREE_TRIAL}`) > -1 ||
  url.indexOf(`/${SIGNUP_ROUTE}/${ONBOARDING_TYPE_SLSP}`) > -1 ||
  url.indexOf(`/${SIGNUP_ROUTE}/${ONBOARDING_TYPE_CSAS}`) > -1;
